(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/printable-coupon/assets/javascripts/printable-coupon-row.js') >= 0) return;  svs.modules.push('/components/pool-betting/printable-coupon/assets/javascripts/printable-coupon-row.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const formatDate = svs.components.poolBetting.utils.formatDate;
const ResultInclinationIndexes = svs.components.sport.tipsenShared.constants.ResultInclinationIndexes;
const getBitmapIndices = svs.components.sport.tipsenShared.bitmap.getBitmapIndices;
const ParticipantName = svs.components.lbUi.participants.ParticipantName;
const DescriptionSize = svs.components.lbUi.participants.constants.DescriptionSize;
const selectSportEvent = svs.components.sportinfo.matchInfoRedux.selectors.selectSportEvent;
const _svs$components$poolB = svs.components.poolBetting.printableCoupon,
  Outcomes = _svs$components$poolB.Outcomes,
  Reductions = _svs$components$poolB.Reductions;
const NO_REDUCTIONS = 7;

const PrintableCouponRow = _ref => {
  var _getBitmapIndices$, _getBitmapIndices;
  let drawEvent = _ref.drawEvent,
    hasPeriods = _ref.hasPeriods,
    participants = _ref.participants,
    signs = _ref.signs,
    _ref$reductions = _ref.reductions,
    reductions = _ref$reductions === void 0 ? NO_REDUCTIONS : _ref$reductions;
  const reductionSelections = (_getBitmapIndices$ = (_getBitmapIndices = getBitmapIndices([reductions])) === null || _getBitmapIndices === void 0 ? void 0 : _getBitmapIndices[0]) !== null && _getBitmapIndices$ !== void 0 ? _getBitmapIndices$ : [];
  const reductionIndices = Object.keys(ResultInclinationIndexes).filter(reductionIndex => reductionSelections.indexOf(parseInt(reductionIndex, 10)) === -1);
  const reductionLabels = reductionIndices.map(reduction => ResultInclinationIndexes[reduction]);
  const sportEvent = useSelector(state => selectSportEvent(state, drawEvent.matchId));
  const matchStart = sportEvent.matchStart;
  return React.createElement("div", {
    className: "pb_print_coupon__row",
    key: drawEvent.eventNumber
  }, hasPeriods && React.createElement("div", {
    className: "event__period"
  }, "Period ".concat(drawEvent.eventNumber)), React.createElement("div", {
    className: "event__number"
  }, drawEvent.eventNumber), React.createElement("div", {
    className: "event__participants"
  }, React.createElement("div", {
    className: "event__participant event__participant--home"
  }, React.createElement(ParticipantName, {
    nameSize: DescriptionSize.Full,
    participant: participants[0]
  })), React.createElement("div", {
    className: "event__participant event__participant--away"
  }, React.createElement(ParticipantName, {
    nameSize: DescriptionSize.Full,
    participant: participants[1]
  }))), React.createElement("div", {
    className: "event__match_start"
  }, formatDate(matchStart, {
    showDayOfWeek: true
  })), React.createElement("div", {
    className: "event__outcomes"
  }, React.createElement(Outcomes, {
    className: "event__outcomes__home",
    signs: signs === null || signs === void 0 ? void 0 : signs[0]
  }), React.createElement(Outcomes, {
    className: "event__outcomes__away",
    signs: signs === null || signs === void 0 ? void 0 : signs[1]
  })), React.createElement(Reductions, {
    reductionLabels: reductionLabels
  }));
};
setGlobal('svs.components.poolBetting.printableCouponRow.PrintableCouponRow', PrintableCouponRow);

 })(window);